const locale = {
  appTitle: "GISCON Map Sandbox EN",
  search: "Search",
};

export default locale;
